import React from "react";

const BlogCard = ({
  displayImage,
  date,
  title,
  description,
  featured = false,
}) => {
  return (
    <div
      className={`bg-background rounded-lg overflow-hidden transition-shadow duration-300 flex flex-col items-center gap-6 h-full ${
        featured ? "md:col-span-2" : ""
      }`}
    >
      <div className="relative w-full rounded-[30px] lg:rounded-3xl h-[256px] md:h-[450px] lg:h-60">
        {displayImage ? (
          <img
            src={displayImage}
            alt={title}
            className="object-cover rounded-[30px] lg:rounded-3xl size-full"
            onError={(e) => {
              e.target.src =
                "https://via.placeholder.com/400x300?text=Blog+Image";
            }}
          />
        ) : (
          <div className="bg-[#F1EFF1]/40 rounded-[30px] lg:rounded-3xl w-full h-[256px] md:h-[450px] lg:h-60" />
        )}
      </div>
      <div className="flex flex-col flex-grow">
        <div className="mb-2">
          <p className="text-sm text-persianIndigo font-semibold">{date}</p>
        </div>

        <h3 className="text-2xl text-darkBlue hover:text-darkPurple lg:text-darkGray font-bold mb-2 leading-tight">
          {title}
        </h3>

        <p className="text-base text-darkGray flex-grow">{description}</p>
      </div>
    </div>
  );
};

export default BlogCard;
